<template>
  <section class="media_and_text" :style="cssVars">
    <div class="container">
      <div
        class="media_and_text__inner"
        :class="{ flip_horizontally: flip_horizontally }"
      >
        <div
          class="media_and_text__inner__text"
          :class="{ flip_horizontally: flip_horizontally }"
        >
          <div class="content_container">
            <h2 v-if="title" v-html="title"></h2>
						<h5 v-if='sub_title' v-html='sub_title'></h5>

            <div class="body" v-if="text" v-html="text"></div>
          </div>

          <div class="cta_container">
            <primary-button
              v-if="parsedPrimaryButton"
              :link="parsedPrimaryButton"
              :label="parsedPrimaryButton.title"
            ></primary-button>
          </div>
        </div>

        <div
          v-if="parsedImageOrVideo === 'image'"
          class="media_and_text__inner__image"
          :class="{ flip_horizontally: flip_horizontally }"
        >
          <img
            :src="parsedImage.sizes.media_text"
            :alt="title"
            :class="{ flip_horizontally: flip_horizontally }"
          />
        </div>
        <video-modal
          v-else
          class="rounded"
          @isModalOpen="getModalData"
          :has_border="'no'"
          :video_poster="parsedVideoPoster.url"
          :video_source="parsedVideo"
          :class="{ flip_horizontally: flip_horizontally }"
        ></video-modal>
      </div>
    </div>
  </section>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
import VideoModal from './VideoModal.vue';

export default {
  data() {
    return {
      theModalStatus: false,
    };
  },

  props: {
    title: {},
		sub_title: {},
    tag: {},
    text: {},
    primary_button: {},
    primary_button_theme: {},
    secondary_button: {},
    secondary_button_type: {},
    secondary_button_theme: {},
    image: {},
    video: {},
    video_poster: {},
    image_or_video: {},
    text_alignment: {},
    flip_horizontally: {},
    size: {},
  },

  computed: {
    fadeDirection() {
      if (this.flip_horizontally === '1') {
        return 'fade-left';
      } else {
        return 'fade-right';
      }
    },

    fadeDirectionAlt() {
      if (this.flip_horizontally === '1') {
        return 'fade-right';
      } else {
        return 'fade-left';
      }
    },

    parsedImage() {
      if (this.image) {
        return JSON.parse(this.image);
      } else {
        return null;
      }
    },

    parsedVideoPoster() {
      if (this.video_poster) {
        return JSON.parse(this.video_poster);
      } else {
        return null;
      }
    },

    parsedVideo() {
      if (this.video) {
        return JSON.parse(this.video);
      } else {
        return null;
      }
    },

    parsedPrimaryButton() {
      if (this.primary_button) {
        return JSON.parse(this.primary_button);
      } else {
        return null;
      }
    },

    parsedSecondaryButton() {
      if (this.secondary_button) {
        return JSON.parse(this.secondary_button);
      } else {
        return null;
      }
    },

    parsedImageOrVideo() {
      if (this.image_or_video) {
        return JSON.parse(this.image_or_video);
      } else {
        return null;
      }
    },

    flipHorizontally() {
      if (this.flip_horizontally === '1') {
        return 'Yes';
      } else {
        return 'No';
      }
    },

    cssVars() {
      return {
        '--text-alignment': this.text_alignment
          ? this.text_alignment
          : 'space-between',
        '--background-colour': this.background_colour,
        '--text-colour': this.text_colour,
        '--size': this.size ? this.size : '1 / span 12',
      };
    },
  },

  watch: {},

  methods: {
    getModalData(arg) {
      this.theModalStatus = arg;
      return arg;
    },
  },

  components: {
    PrimaryButton,
    VideoModal,
  },

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.media_and_text {
  /* overflow: hidden; */

  @media (max-width: 768px) {
    overflow-x: hidden;
  }

  &__inner {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-column: var(--size);

    @media (max-width: 1024px) {
      grid-template-columns: 1fr 1fr;
      grid-column: 1 / span 4;
    }

    &.flip_horizontally {
      padding-bottom: unset;

      @media (max-width: 768px) {
        grid-column: 1 / span 4;
      }
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      column-gap: 0;
      // row-gap: var(--spacer);
      grid-column: span 4;
    }

    .video {
      overflow: hidden;

      &.flip_horizontally {
        order: 0;

        @media (max-width: 768px) {
          order: 0;
        }
      }
    }

    &__image {
      grid-column: span 1;
      // background: #ededed 0% 0% no-repeat padding-box;
      opacity: 1;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      height: 500px;
      overflow: hidden;

      @media (max-width: $tablet) {
        min-height: unset;
      }

      @media (max-width: 768px) {
        border-radius: 0;
      }

      &.flip_horizontally {
        order: 0;
        justify-content: flex-end;

        @media (max-width: 768px) {
          order: 0;
        }
      }

      @media (max-width: 768px) {
        grid-column: 1 / span 4;
        margin-right: 0;
        /* aspect-ratio: 4 / 3.5; */
        min-height: auto;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: 0.2s ease all;
        transform: scale(1);

        // &:hover {
        // 	transition: 0.2s ease all;
        // 	transform: scale(1.2);
        // }

        @media (max-width: 768px) {
          object-fit: cover;
        }
      }
    }

    &__text {
      grid-column: span 1;
      opacity: 1;
      display: flex;
      flex-direction: column;
      justify-content: var(--text-alignment);
      gap: var(--gutter-tablet-desktop);
      font: normal normal 300 18px/28px var(--primary-font-family);
      padding: 0 50px 0 0;
      position: relative;
      gap: 30px;

      @media (max-width: 768px) {
        gap: 16px;
        order: 1;
        padding: 24px 0 0 0;
        border-radius: 0;
      }

      &.flip_horizontally {
        order: 1;
        padding: 0 0 0 50px;

        @media (max-width: 768px) {
          order: 1;
          padding: 24px 0 0 0;
        }
      }

      h2 {
        color: var(--black);
        margin: 0;
        margin-bottom: 0;
        z-index: 10;
        /* font: normal normal bold 42px/44px var(--primary-font-family-display); */
        /* text-transform: unset; */
      }

			h5 {
				font: normal normal 300 20px/28px var(--primary-font-family);
				color: var(--purple);
				margin-top: 0;
			}

      @media (max-width: 768px) {
        grid-column: 1 / span 4;
        // padding: 0 var(--spacer);

        h2 {
          text-align: left;
        }

        .the_subtitle {
          text-align: center;
        }
      }

      .wpforms-container-full,
      .wpcf7-form {
        margin-top: var(--spacer);
      }

      .the_subtitle {
        font: normal normal 800 18px/28px var(--primary-font-family);
        z-index: 10;

        &::v-deep {
          p {
            margin: 0;
            font: normal normal 800 18px/28px var(--primary-font-family);

            @media (max-width: 768px) {
              text-align: left;
            }
          }
        }
      }

      .text,
      .body {
        z-index: 10;

        &::v-deep {
          p {
            margin: 0;
            font: normal normal normal 16px/24px var(--primary-font-family);
            color: var(--black);

            @media (max-width: 768px) {
              text-align: left;
            }
          }

          ul,
          ol {
            display: flex;
            flex-direction: column;
            margin: var(--gutter-tablet-desktop) 0 var(--gutter-tablet-desktop);
            padding: 0 0 0 12px;

            li {
              font: normal normal normal 16px/24px var(--primary-font-family);
            }
          }
        }
      }

      .cta_container {
        margin-top: 0;
        z-index: 10;
        max-width: calc(100% - calc(113px - 54px));
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 16px;

        @media (max-width: 768px) {
          margin-top: (32px - 16px);
          text-align: left;
          display: flex;
          flex-wrap: wrap;
          gap: var(--spacer-mobile);
        }

        .site_button {
          margin-right: 0;
        }
      }

      .content_device {
        position: absolute;
        right: 0;
        bottom: 0;

        @media (max-width: 768px) {
          height: 112px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/MediaAndText.vue